import { render, staticRenderFns } from "./ConnectBitGo.vue?vue&type=template&id=337b663e&"
import script from "./ConnectBitGo.vue?vue&type=script&lang=js&"
export * from "./ConnectBitGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports